import {
  createPropertyRequest,
  CreatePropertyRequestType,
  deletePropertyRequest,
  editPropertyRequest,
  fetchCertainPropertyRequest,
  fetchPropertiesRequest,
  uploadBulkCsvRequest,
  uploadCsvRequest,
} from 'api';
import { PaginationType } from 'common';
import { Pagination } from 'enums';
import {
  setAuthLoading,
  setProperties,
  setPropertiesAfterScroll,
  setPropertiesPagination,
  setCertainProperty,
  setUploadedCsv,
  setNotification,
  setPropertiesLoadingStatus,
} from 'state/actions';
import { AppRootStateType } from 'state/reducers';
import { TypedDispatch } from 'state/types';

export const fetchProperties =
  (isScroll: boolean) =>
  async (dispatch: TypedDispatch, getState: () => AppRootStateType) => {
    const { page, search } = {
      page: isScroll ? getState().properties.page : Pagination.START_PAGE,
      search: getState().properties.search.trim(),
    };

    try {
      dispatch(setPropertiesLoadingStatus(true));
      const response = await fetchPropertiesRequest({
        page,
        q: search || undefined,
        take: Pagination.TAKE,
      });
      const pagination: PaginationType = {
        page: response?.data.page,
        count: response?.data.count,
      };

      dispatch(setPropertiesPagination(pagination));
      dispatch(
        isScroll
          ? setPropertiesAfterScroll(response?.data.rows)
          : setProperties(response?.data.rows),
      );
    } finally {
      dispatch(setPropertiesLoadingStatus(false));
    }
  };

export const fetchCertainProperty = (id: string) => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setAuthLoading(true));
    const response = await fetchCertainPropertyRequest(id);

    dispatch(setCertainProperty(response?.data));
  } finally {
    dispatch(setAuthLoading(false));
  }
};

export const createProperty =
  (data: CreatePropertyRequestType) => async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await createPropertyRequest(data);

      return response?.status;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };

export const editProperty =
  (user: CreatePropertyRequestType & { id: string }) =>
  async (dispatch: TypedDispatch) => {
    try {
      dispatch(setAuthLoading(true));
      const response = await editPropertyRequest(user);

      dispatch(setNotification(response?.data?.message));

      return response?.status;
    } finally {
      dispatch(setAuthLoading(false));
    }
  };

export const deleteProperty = (id: string) => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setAuthLoading(true));
    const response = await deletePropertyRequest(id);

    dispatch(setNotification(response?.data?.message));

    return response?.status;
  } finally {
    dispatch(setAuthLoading(false));
  }
};

export const fetchUploadedCsv = (file: File) => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setAuthLoading(true));
    const response = await uploadCsvRequest(file);

    dispatch(setUploadedCsv(response?.data ?? []));

    return response?.status;
  } finally {
    dispatch(setAuthLoading(false));
  }
};

export const importPropertiesFromCsv = (file: any) => async (dispatch: TypedDispatch) => {
  try {
    dispatch(setAuthLoading(true));
    const response = await uploadBulkCsvRequest(file);

    return response?.status;
  } finally {
    dispatch(setAuthLoading(false));
  }
};
